<template>
  <div class="promoweek-detail">
    <div class="banner-area">
      <ul class="btns">
        <li :class="{ on: currentIndex === 0 }" @click="currentIndex = 0"></li>
        <li :class="{ on: currentIndex === 1 }" @click="currentIndex = 1"></li>
      </ul>

      <div class="section section-action" :class="currentIndex === 0 ? 'flow' : 'order'">
        <p class="section-title bonus" v-show="currentIndex === 0"></p>
        <p class="section-title order" v-show="currentIndex === 1"></p>

        <div class="info-row" v-show="currentIndex === 0">
          <p><span>会员：</span><em>{{ userName }}</em></p>
          <p><span>奖金金额：</span><em>{{ bonus }}</em></p>
          <p><span>上周总流有效流水：</span><em>{{ bet }}</em></p>
        </div>

        <input
          v-show="currentIndex === 1"
          type="text"
          v-model="order"
          placeholder="请输入注单编号"
        />

        <div class="btn-row" v-show="currentIndex === 0">
          <a
            href="javascript:;"
            class="btn-claim"
            v-if="!already"
            @click="appWeeklyBetPromoAsync()"
          ></a>
          <a href="javascript:;" class="btn-claim claimed" v-else></a>
        </div>

        <div class="btn-row" v-show="currentIndex === 1">
          <a href="javascript:;" class="btn-claim" @click="insertPromoSelfAsync()"></a>
        </div>
      </div>
    </div>

    <div class="section section-detail" :class="currentIndex === 0 ? 'flow' : 'order'">
      <p class="section-title content"></p>
      <p class="cd" v-show="currentIndex === 0">
        全体Boss会员每周根据流水投注，每周可领取最高2,888的奖金任务，奖金只需3倍流水。
      </p>
      <p class="cd" v-show="currentIndex === 1">
        体育和电竞平台中投注游戏，注单尾号达AAA以上组合(111/222/333/...)，并且当日申请的注单投注达到指定金额，无论输赢均可领取奖励。
      </p>

      <dl class="rule-list week" v-show="currentIndex === 0">
        <dd class="rule-row">
          <span>周体育总有效投注流水</span>
          <span>奖金</span>
          <span>流水要求</span>
        </dd>
        <dd class="rule-row"><span>5,000</span><span>58</span><span>3倍</span></dd>
        <dd class="rule-row"><span>30,000</span><span>128</span><span>3倍</span></dd>
        <dd class="rule-row"><span>50,000</span><span>228</span><span>3倍</span></dd>
        <dd class="rule-row"><span>100,000</span><span>388</span><span>3倍</span></dd>
        <dd class="rule-row"><span>120,000</span><span>588</span><span>3倍</span></dd>
        <dd class="rule-row"><span>250,000</span><span>888</span><span>3倍</span></dd>
        <dd class="rule-row"><span>400,000</span><span>1,288</span><span>3倍</span></dd>
        <dd class="rule-row"><span>500,000</span><span>1,888</span><span>3倍</span></dd>
        <dd class="rule-row"><span>1,000,000</span><span>2,888</span><span>3倍</span></dd>
      </dl>

      <dl class="rule-list order" v-show="currentIndex === 1">
        <dd class="rule-row">
          <span>注单尾号要求</span>
          <span>投注最低要求</span>
          <span>获奖倍数</span>
          <span>彩金上限</span>
          <span>流水要求</span>
        </dd>
        <dd class="rule-row">
          <span>后3位为AAA</span><span>20</span><span>本金的30%</span><span>88</span><span>5倍</span>
        </dd>
        <dd class="rule-row">
          <span>后4位为AAAA</span><span>20</span><span>本金的3倍</span><span>388</span><span>5倍</span>
        </dd>
        <dd class="rule-row">
          <span>后5位为AAAAA</span><span>20</span><span>本金的10倍</span><span>1,688</span><span>5倍</span>
        </dd>
        <dd class="rule-row">
          <span>后6位为AAAAAA</span><span>20</span><span>本金的100倍</span><span>8,888</span><span>5倍</span>
        </dd>
      </dl>
    </div>

    <div class="rule-section">
      <p class="section-title rule"></p>
      <div class="rule-text" v-show="currentIndex === 0">
        1.有效投注统计时间；周一12：00至次周一11：59：59；领取时间为次周一20：00至次周五23：59：59，逾期视为放弃。<br />
        2.体育注单必须是投注于独赢盘，让球盘，大小三个盘口，允许投注于半场或全场及滚球；任何无效投注、取消的投注、未产生胜负或赔率低于欧洲盘1.75，香港盘0.75的注单将不能用累积有效投注额<br />
        3.每位有效玩家、每一手机号码、电子邮箱、相同银行卡、每一个IP地址、每一台电脑者每周只能享受一次优惠，如发现有违规者我们将保留无限期审核扣回红利的权利
      </div>
      <div class="rule-text" v-show="currentIndex === 1">
        1.此优惠依照平台时间为准每位会员每天只可申请一次，如同一天有多笔注单以第一笔提交的优先申请派发，注单需在24小时内提交申请，逾期无效<br />
        2.中奖有效注单必须出自IMSP/XJ体育或者IMES/TF电竞平台，单笔≥20元且产生输赢结果的注单<br />
        3.奖金需在体育或电竞平台内完成5倍流水<br />
        4.对已结算并产生输赢结果的投注额进行计算流水，任何平局、取消的赛事、赔率低于欧洲盘1.75，香港盘0.75 、输半/赢半以及对押的投注将不计算在有效投注内<br />
        5.此优惠不与体育返水以外的任何优惠类型共享
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryBetAmount,
  queryWeeklyBetPromo,
  appWeeklyBetPromo,
  insertPromoSelf
} from '../api';
import { getStore } from '~/config/utils';

export default {
  name: 'PromoWeekPromo',
  data() {
    return {
      currentIndex: 0,
      order: '',
      bet: '--',
      userName: '',
      bonus: '--',
      already: false
    };
  },
  created() {
    this.userName = getStore('UserName') || '';
    this.queryBetAmountAsync();
    this.queryWeeklyBetPromoAsync();
  },
  methods: {
    async queryBetAmountAsync() {
      const result = await queryBetAmount();
      if (!result.Message) {
        this.bet = result.Result;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async queryWeeklyBetPromoAsync() {
      const result = await queryWeeklyBetPromo();
      if (!result.Message) {
        this.bonus = result.Result;
        this.already = result.Code;
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async appWeeklyBetPromoAsync() {
      const result = await appWeeklyBetPromo();
      if (!result.Message) {
        this.$toast.success('领取成功');
        this.queryWeeklyBetPromoAsync();
      } else {
        this.$toast.fail(result.Message);
      }
    },
    async insertPromoSelfAsync() {
      if (!this.order) {
        return this.$toast.fail('请输入注单号');
      }
      const result = await insertPromoSelf(10006, this.order, 10);
      if (!result.Message) {
        this.$toast.success('申请成功');
      } else {
        this.$toast.fail(result.Message);
      }
    }
  }
};
</script>

<style scoped>
.promoweek-detail {
  width: 100%;
  max-width: 100%;
  margin-top: 0.24rem;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
  border-radius: 0.16rem;
  overflow: hidden;
  background-color: #060c2d;
  font-family: 'Microsoft YaHei', sans-serif;
}

.promoweek-detail ul,
.promoweek-detail dl {
  padding: 0;
  margin: 0;
  list-style: none;
}

.promoweek-detail a {
  text-decoration: none;
}

/* 顶图 + Tab + 领取区 */
.banner-area {
  width: 100%;
  background: url('~@/img/promoweek-pc/pc-bg.jpg') no-repeat center top;
  background-size: 100% auto;
}

.banner-area ul.btns {
  display: flex;
  justify-content: center;
  gap: 0.24rem;
  width: 12rem;
  max-width: 100%;
  margin: 0 auto;
  padding-top: 4.9rem;
}

.banner-area ul.btns li {
  width: 4.16rem;
  height: 1.4rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.banner-area ul.btns li:first-child {
  background-image: url('~@/img/promoweek-pc/tab-flow-off.png');
}

.banner-area ul.btns li:first-child.on {
  background-image: url('~@/img/promoweek-pc/tab-flow-on.png');
}

.banner-area ul.btns li:last-child {
  background-image: url('~@/img/promoweek-pc/tab-order-off.png');
}

.banner-area ul.btns li:last-child.on {
  background-image: url('~@/img/promoweek-pc/tab-order-on.png');
}

/* PC 卡片：12rem 宽，发光描边 + 顶图条 */
.section {
  width: 12rem;
  max-width: calc(100% - 0.48rem);
  margin: 0.24rem auto 0;
  box-sizing: border-box;
  border-radius: 0.2rem;
  padding: 0.28rem 0.36rem 0.36rem;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
}

.section-action.flow {
  background-image: url('~@/img/promoweek-pc/card-flow-bonus-bg.png');
  background-color: #08145e;
}

.section-action.order {
  background-image: url('~@/img/promoweek-pc/card-order-input-bg.png');
  background-color: #08145e;
}

.section-detail.flow {
  background-image: url('~@/img/promoweek-pc/card-flow-detail-bg.png');
  background-color: #07124f;
}

.section-detail.order {
  background-image: url('~@/img/promoweek-pc/card-order-detail-bg.png');
  background-color: #07124f;
}

.section-title {
  width: 3.46rem;
  height: 0.32rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.section-title.bonus {
  background-image: url('~@/img/promoweek-pc/title-bonus.png');
}

.section-title.content {
  background-image: url('~@/img/promoweek-pc/title-content.png');
}

.section-title.order {
  background-image: url('~@/img/promoweek-pc/title-order.png');
}

.section-title.rule {
  width: 3.46rem;
  background-image: url('~@/img/promoweek-pc/title-rule.png');
}

/* 会员信息：PC 横排一行 */
.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.12rem;
  min-height: 0.56rem;
  margin-top: 0.24rem;
  padding: 0.1rem 0.2rem;
  border-radius: 0.08rem;
  background: rgba(6, 10, 45, 0.72);
}

.info-row p {
  margin: 0;
  font-size: 0.16rem;
  line-height: 1.4;
  color: #fff;
  white-space: nowrap;
}

.info-row em {
  font-style: normal;
  font-weight: 600;
  color: #f5e06b;
}

.section-action input {
  display: block;
  width: 100%;
  height: 0.64rem;
  border: none;
  border-radius: 0.12rem;
  background: rgba(6, 10, 45, 0.72);
  font-size: 0.18rem;
  color: #fff;
  text-align: center;
  margin-top: 0.24rem;
  outline: none;
}

.section-action input::placeholder {
  color: rgba(176, 192, 255, 0.5);
}

/* PC 双按钮横排 */
.btn-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.32rem;
  margin-top: 0.24rem;
}

.btn-row .btn-claim {
  display: block;
  width: 2.12rem;
  height: 0.48rem;
  background: url('~@/img/promoweek-pc/btn-claim.png') no-repeat center;
  background-size: 100% 100%;
  cursor: pointer;
}

.btn-row .btn-claim.claimed {
  background-image: url('~@/img/promoweek-pc/btn-claimed.png');
  cursor: default;
}

.section .cd {
  width: 100%;
  margin: 0.24rem auto 0;
  color: #b0c0ff;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  font-size: 0.16rem;
  line-height: 1.7;
  text-align: center;
}

.section dl {
  width: 100%;
  color: #fff;
  font-weight: bold;
  text-align: center;
  margin: 0.24rem auto 0;
}

.section dl dd {
  display: flex;
}

.section dl dd:first-child {
  min-height: 0.56rem;
  background: linear-gradient(90deg, #2f4fff 0%, #4a63ff 45%, #6a5bff 100%);
}

.section dl.week dd {
  min-height: 0.44rem;
}

.section dl dd span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.14rem;
  text-align: center;
  padding: 0.06rem 0.04rem;
  flex: 1;
  line-height: 1.3;
}

.section dl dd:first-child span {
  font-size: 0.16rem;
}

.section dl dd:not(:first-child) {
  color: #ffeeaf;
}

.section dl dd:not(:first-child) span {
  border: 1px solid #4f56ed;
}

.section dl.order dd span:nth-child(1) {
  flex: 1.35;
}

.section dl.order dd span:nth-child(2) {
  flex: 0.65;
}

.section dl.order dd span:nth-child(3) {
  flex: 0.95;
}

.section dl.order dd span:nth-child(4) {
  flex: 0.85;
}

.section dl.order dd span:nth-child(5) {
  flex: 0.65;
}

/* 活动规则：无卡片框，直接落在底色上 */
.rule-section {
  width: 12rem;
  max-width: calc(100% - 0.48rem);
  margin: 0.28rem auto 0;
}

.rule-section .rule-text {
  padding: 0 0.08rem;
  font-size: 0.16rem;
  color: #b0c0ff;
  line-height: 1.85;
  margin-top: 0.16rem;
}
</style>
